import { render, staticRenderFns } from "./screen-size-alert.vue?vue&type=template&id=d5a50b0e&scoped=true&"
import script from "./screen-size-alert.vue?vue&type=script&lang=ts&"
export * from "./screen-size-alert.vue?vue&type=script&lang=ts&"
import style0 from "./screen-size-alert.vue?vue&type=style&index=0&id=d5a50b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a50b0e",
  null
  
)

export default component.exports